import { SearchInputEventData, searchEvent, searchInputEventUpdate, searchInputEventInit } from "./search-events";

export default class SearchInput {
    searchInput: HTMLInputElement;
    submitButton: HTMLButtonElement;
    toggleAdvancedFilters: HTMLElement = null;
    advancedFilters: HTMLElement[];
    timeout: any;
    resetButton: HTMLElement;
    searchForm: HTMLFormElement;
    searchTimeout: NodeJS.Timeout | null = null;
    constructor(elementID: string) {
        this.searchForm = document.querySelector(`form#${elementID}`) as HTMLFormElement;
        this.searchInput = document.querySelector(`#${elementID} input`) as HTMLInputElement;
        this.submitButton = document.querySelector(`#${elementID} .search-input__button`) as HTMLButtonElement;
        this.resetButton = document.querySelector('.remove-button');
    }
    Init() {
        if (this.searchInput != null) {
            // Fetch the 'keyword' query string
            const urlParams = new URLSearchParams(window.location.search);

            if (urlParams.has('keyword')) {
                // If 'keyword' is not null, use it as the default value
                this.searchInput.value = urlParams.get('keyword');
                setTimeout(() => {

                const initEventData: SearchInputEventData = {
                    searchInput: this.searchInput.value
                }
                searchEvent.emit(searchInputEventInit, initEventData);
                }, 500)
            }
        }
        this.ShowHideResetButton()

        this.AttachEventListeners();
    }
    AttachEventListeners() {
        this.searchInput.addEventListener('input', () => this.ShowHideResetButton())
        this.searchForm.addEventListener('submit', (e: KeyboardEvent) => {
            e.preventDefault();
            this.SubmitSearch();
        });

        this.resetButton.addEventListener('click', () => {
            this.ResetInput()
            this.resetButton.style.display = "none";
            this.SubmitSearch();
        })
    }
    SubmitSearch() {
        //Event Data
        const updateEventData: SearchInputEventData = {
            searchInput: this.searchInput.value
        }
        searchEvent.emit(searchInputEventUpdate, updateEventData);
        window.history.replaceState(null, null, `?keyword=${this.searchInput.value}`);
    }

    ResetInput() {
        this.searchInput.value = "";
        this.searchInput.focus();
    }
    ShowHideResetButton() {
        if (this.searchInput.value != "") {
            this.resetButton.style.display = "block";
        } else {
            this.resetButton.style.display = "none";
        }
    }
}
